module.exports = __webpack_public_path__ + "static/media/helper.87a08e72.svg";